import { compose, bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { Form } from 'antd';
import { get } from 'lodash';

import { createTicket, fetchTicket, updateTicket, clearTicket } from '../../eventActions';

import EventAdminCampaignTicketForm from './EventAdminCampaignTicketForm';

const mapStateToProps = state => ({
  locale: get(state, 'session.language'),
  languages: get(state, 'platform.languages'),
  campaign: get(state, 'campaign.campaign', {}),
  organization: get(state, 'organization.organization'),
  isSaveTicketInProgress: get(state, 'Event.isSaveTicketInProgress'),
  ticket: get(state, 'Event.ticket'),
  tickets: get(state, 'Event.tickets'),
  eventEndOn: get(state, 'Event.event.endOn'),
  isUpdateTicketInProgress: get(state, 'Event.isUpdateTicketInProgress')
});

const mapDispatchToProps = dispatch => bindActionCreators({
  createTicket,
  fetchTicket,
  updateTicket,
  clearTicket
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  Form.create()
)(EventAdminCampaignTicketForm);
